import { Stack } from "@mui/material";
import React from "react";
import { ITaskListItem } from "source/models/task";
import { Translations } from "ui/Scripts/source/models/translations";
import { ListStateIconFresh } from "source/components/framework/List/ListStateIconFresh";
import { ListStateIconLocked } from "source/components/framework/List/ListStateIconLocked";
import { TaskStateListChip } from "../TaskStateListChip";
import { ListStateIconUnread } from "source/components/framework/List/ListStateIconUnread";
import { ListStateIconNotification } from "source/components/framework/List/ListStateIconNotification";
import { ListStateIconPrivate } from "source/components/framework/List/ListStateIconPrivate";
import { TaskHandlerType } from "ui/Scripts/source/models/enums";
import { ListStateIconPersons } from "source/components/framework/List/ListStateIconPersons";
import { Base } from "ui/Scripts/source/framework/base";
import { ListStateIconArchived } from "source/components/framework/List/ListStateIconArchived";
import { ListStateIconReadOnly } from "source/components/framework/List/ListStateIconReadOnly";

interface ITaskListStateColProps {
    item: ITaskListItem
}

export const TaskListStateCol = (props: ITaskListStateColProps) => {
    const taskHandlers = props.item.handlers.filter(i => i.taskHandlerType === TaskHandlerType.Handler);

    return (
        <Stack direction="row" useFlexGap flexWrap="nowrap" overflow="hidden" alignItems="center">
            <TaskStateListChip
                icon={props.item.isArchived ? <ListStateIconArchived hideTooltip={true} /> : undefined}
                code={props.item.isArchived ? Translations.Archived : props.item.stateCode}
                color={props.item.isArchived ? "EBEBEB" : props.item.stateColor}
            />
            <ListStateIconUnread unread={!props.item.isRead} />
            <ListStateIconFresh date={props.item.modifyUser.date} />
            {!props.item.unitCode &&
                <ListStateIconPrivate />
            }
            {props.item.calendarTaskCount > 0 &&
                <ListStateIconNotification tooltip={`${Translations.OpenCalendarTasks}: ${props.item.calendarTaskCount}`} />
            }
            {taskHandlers.length > 0 &&
                <ListStateIconPersons tooltip={`${Translations.TaskHandlers}: ${Base.getStringWithSeparators(taskHandlers.map(i => i.name), ", ")}`} />
            }
            <ListStateIconReadOnly readOnly={props.item.isReadOnly} />
            <ListStateIconLocked locked={props.item.locked} />
        </Stack>
    );
};
